import { FC } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Button, Card, Row } from 'antd';
import InvoiceUploader from '../invoice_uploader/InvoiceUploader';
import * as React from 'react';
import { isInternalTech } from '../../utils/AuthUtils';
import { compareStrings } from '../../utils/DataAccessUtils';
import { capitalize, joinList } from '../../utils/DataFormatterUtils';
import InvoiceEditButton from '../invoice_edit_button/InvoiceEditButton';
import { getInvoiceMissingProperties } from '../invoice_utilities/InvoiceUtilities';
import InvoiceAddRequiredFieldsModal from '../invoice_add_required_fields_modal/InvoiceAddRequiredFieldsModal';

const InvoiceDraftBanner: FC<any> = ({
	userType,
	currentUser,

	invoice,
	generateInvoicePDF,
	handleInvoicePDFUploadChange,
	generatingPDF,
}) => {
	const { missingInvoiceNumber, missingDateOfInvoice, missingPDFLink, missingAProperty } =
		getInvoiceMissingProperties(invoice);
	const bannerMessage = [];
	const bannerMessageDesc = [];
	if (missingPDFLink) {
		bannerMessage.push('upload an invoice file');
		bannerMessageDesc.push('invoice file (PDF)');
	}
	if (missingDateOfInvoice) {
		bannerMessage.push('add an invoice number');
		bannerMessageDesc.push('invoice number');
	}
	if (missingInvoiceNumber) {
		bannerMessage.push('add an invoice date');
		bannerMessageDesc.push('invoice date');
	}

	const bannerMessageTitle = capitalize(joinList(bannerMessage));
	const bannerMessageDescription = joinList(bannerMessageDesc);

	return !isInternalTech(currentUser) &&
		compareStrings(invoice.status, 'draft') &&
		missingAProperty ? (
		<div className="rowSpacing">
			<Card
				style={{ border: '1px solid #8ed7eb' }}
				bodyStyle={{
					padding: '16px 24px',
					background: '#ebfbff',
				}}
			>
				<div>
					<h5 style={{ marginBottom: '4px' }}>{bannerMessageTitle}</h5>
					<div>
						<p
							style={{
								fontSize: 16,
								marginBottom: '0.5em',
							}}
						>
							Please add an {bannerMessageDescription} for this invoice before submitting it.
						</p>
						<Row>
							{missingPDFLink ? (
								<span style={{ marginRight: 12 }}>
									<InvoiceUploader
										roleType={userType}
										invoiceId={invoice.id}
										invoice={invoice}
										buttonType="primary"
										defaultFileList={[]}
										multiple={false}
										handleUploadSuccess={handleInvoicePDFUploadChange(invoice)}
									/>
								</span>
							) : null}
							{missingDateOfInvoice || missingInvoiceNumber ? (
								<InvoiceAddRequiredFieldsModal
									invoice={invoice}
									style={{}}
									type={missingPDFLink ? 'default' : 'primary'}
								/>
							) : null}
						</Row>
						{missingPDFLink ? (
							<p style={{ marginBottom: 0, marginTop: 8 }}>
								Don't have an invoice file?{' '}
								<Button
									loading={generatingPDF}
									type="link"
									onClick={() => generateInvoicePDF(invoice.id)}
								>
									Generate PDF
								</Button>
							</p>
						) : null}
					</div>
				</div>
			</Card>
		</div>
	) : null;
};

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
});

const ComponentWithoutUserType = withRouter(connect(mapStateToProps, () => {})(InvoiceDraftBanner));

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
